export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/caricature.7aed5c8.svg";